module.exports = __webpack_public_path__ + "static/never-split-the-difference-f0ef35a358c0786e8693e33a12efd63e.jpg";